<template>
	<div class="quote-flowX-overview">
		<div class="stock-info-box">
			<FlowXStockPrice :stock-quote-data="stockQuoteData" />
			<FlowXStockIndex :stock-quote-data="stockQuoteData" />
		</div>
		<AbbeChat ref="refAbbeChat" class="stock-box-chart" />
	</div>
</template>

<script setup>
import AbbeChat from '@/rebuild/materials/shared/quote/AbbeChat.vue';
import FlowXStockPrice from '@/rebuild/materials/shared/quote/flowXStockPrice.vue';
import FlowXStockIndex from '@/rebuild/materials/shared/quote/flowXStockIndex.vue';
import { ref, computed, onMounted } from 'vue';
import { useModuleData } from '@/rebuild/hooks/data/useModuleData';

const { quote } = useModuleData();

const stockQuoteData = computed(() => quote.data?.data || {});

const fetchStockQuote = async () => {
	await quote.refresh();
};

const refAbbeChat = ref();
const refreshComponent = async () => {
	await fetchStockQuote();
	if (!quote.empty) {
		refAbbeChat.value && refAbbeChat.value.refresh();
	}
};

onMounted(() => {
	refreshComponent();
});
</script>

<style lang="less" scoped>
.stock-info-box {
	display: flex;
	justify-content: space-between;
}

.stock-box-chart {
	width: 100%;
	margin-top: 36px;
}
</style>
